var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { width, height, borderRadius } from 'styled-system';
import { getPaletteColor, borderRadiusAttrs, borderRadiusValues, applyVariations, roundedValues, } from '../utils';
var variations = {
    parallax: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-attachment: fixed;\n  "], ["\n    background-attachment: fixed;\n  "]))),
    static: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-attachment: scroll;\n  "], ["\n    background-attachment: scroll;\n  "]))),
};
var image = function (props) { return (props.image ? { backgroundImage: "url(".concat(props.image, ")") } : null); };
var propTypes = __assign(__assign(__assign(__assign({}, height.propTypes), width.propTypes), borderRadius.propTypes), { 
    /** background-image url */
    image: PropTypes.string, variation: PropTypes.oneOf(Object.keys(variations)), borderRadiusSize: PropTypes.oneOf(borderRadiusValues), rounded: PropTypes.oneOf(roundedValues) });
var BackgroundImage = styled.div.attrs(borderRadiusAttrs)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  ", "\n  ", " ", " ", " ", ";\n"], ["\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  ", "\n  ", " ", " ", " ", ";\n"])), getPaletteColor('border.light'), applyVariations('BackgroundImage', variations), image, height, width, borderRadius);
BackgroundImage.propTypes = propTypes;
BackgroundImage.defaultProps = {
    variation: 'static',
};
BackgroundImage.displayName = 'BackgroundImage';
export default BackgroundImage;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=BackgroundImage.js.map